import styled from "styled-components";
import compassSingleChild from "../../../images/compassSingleChild.png";
import profile from "../../../images/profile.png"
import profileUpdate from "../../../images/compassSingleChildUpdate.png";
import compassGroupChild from "../../../images/compassGroupChild.png";
import compassSponsor from "../../../images/compassSponsor.png"
import education from "../../../images/educationCarousel.png"
import educationSelected from "../../../images/educationSelected.png"
import health from "../../../images/health.png"
import healthSelected from "../../../images/healthSelected.png"
import personalDevelopment from "../../../images/personalDevelopment.png"
import personalDevelopmentSelected from "../../../images/personalDevelopmentSelected.png"
import water from "../../../images/water.png"
import waterSelected from "../../../images/waterSelected.png"
import compassIndicator from "../../../images/compassIndicator.svg"
import dot from "../../../images/Dot.svg"
import linecompass from "../../../images/linecompass.svg"
import community from "../../../images/community.png"
import communitSelected from "../../../images/communitySelected.png"
import compassGroupTwo from "../../../images/grouptwo.png"
import compassGroupTwoSelected from "../../../images/grouptwoselected.png"
import compassGroupThree from "../../../images/groupthree.png"
import compassGroupThreeSelected from "../../../images/groupthreeselected.png"
import compassGroupFive from "../../../images/groupfive.png"
import compassGroupFiveSelected from "../../../images/groupfiveselected.png";
import compassGroupChildUnselected from "../../../images/compassGroupChildUnselected.png"
import compasssingleSelected from "../../../images/compassSingleChildUpdate.png";
import profilenight from "../../../images/profile-night.png"
import profileUpdatenight from "../../../images/compassSingleChildUpdate-night.png";
import educationnight from "../../../images/educationCarousel-night.png"
import educationSelectednight from "../../../images/educationSelected-night.png"
import healthnight from "../../../images/health-night.png"
import healthSelectednight from "../../../images/healthSelected-night.png"
import personalDevelopmentnight from "../../../images/personalDevelopment-night.png"
import personalDevelopmentSelectednight from "../../../images/personalDevelopmentSelected-night.png"
import waternight from "../../../images/water-night.png"
import waterSelectednight from "../../../images/waterSelected-night.png"
import communitynight from "../../../images/community-night.png"
import communitSelectednight from "../../../images/communitySelected-night.png"


export const Compass = styled.div`
    display: ${props=>props.mapView==="globe"?"block":"none"};
    background-image: ${props=>props.mapView==="default"? "linear-gradient(rgb(33, 45, 104) 60%, rgb(30, 46, 115), rgba(30, 46, 115, 0.49), rgba(30, 46, 115, 0))": ""};
@media screen and (max-width: 740px){
    position: absolute;
    display: block;
    left: 32%;
    top: ${props=>props.isCelebrationChild ? "8.5rem" : props.mapView==="default"?"40px":"5rem"};
    z-index: ${props=>props.mapView==="default"?"9":"1"};
}
@media screen and (max-width: 480px){
    position: absolute;
    display: block;
    left: 0;
    right:0;
    margin-right:auto;
    margin-left:auto;
    top: ${props=>props.isCelebrationChild ? "10rem" : props.mapView==="default"?"40px":"5rem"};
    z-index: ${props=>props.mapView==="default"?"9":"1"};
}
@media screen and (max-width: 375px){
    top: ${props=>props.mapView==="default"?"40px":"0px"};
    position: ${props=>props.community?"relative":"absolute"};
}


@media only screen and (min-device-width: 750px) and (max-device-width: 1199px) and (orientation : portrait){ 
    position: absolute;
    display: block;
    left: 10%;
    top: 15%;
    position: absolute;
    width:80%;
    z-index: 9;
    background-image:none;
    top: ${props=>props.isCelebrationChild ? "15.5rem" : props.mapView==="default"?"40px":"6rem"};
}

@media only screen and (min-device-width: 750px) and (max-device-width: 1199px) and (orientation : landscape){ 
    position: absolute;
    display: block;
    left: 27%;
    top: 7rem;
    position: absolute;
    width:45%;
    z-index: 9;
    background-image:none;
}
.map-navigation{
    width:300px;
    margin:0 auto;
    padding-top:30px;
    z-index:11;
    position:relative;
    @media screen and (min-width: 330px) and (max-width: 365px){
        width: 255px;
    }
}
.community-home-nav{
    width:100%;
    margin:0 auto;
    padding-top:30px;
    z-index:11;
    position:relative;
}
.map-navigation .icon-container{
    width: 100%;
    text-align: center;
    position: relative;
}
.map-navigation .icon-container button{
    bottom:8px;
    position:relative;
}
.map-navigation .icon-container button.single, .map-navigation .icon-container button.group{
    width: 30px;
    height: 30px;
    margin-bottom: 20px;
    bottom: unset;
    position: relative;
}

.map-navigation .icon-container .sponsor{
    background:url(${props=>props?.item?.image&&props?.item?.image.length>0?props?.item?.image:compassSponsor}) 0 0 ;
    background-size: cover;
    width:50px;
    height: 50px;
 }
.map-navigation .icon-container .single{ 
    background:url(${compassSingleChild}) 0 0;
    background-size: cover;
    width:50px;
    height: 50px;
}
.map-navigation .icon-container .singleSelected{ 
    background:url(${compasssingleSelected}) 0 0;
    background-size: cover;
    width:50px;
    height: 50px;
}

.singleChildSmall{ 
    background-size: contain !important;
    background-repeat: no-repeat !important;
    margin-top:5%;
}
.map-navigation .icon-container .multipleChildSmall{
    max-width:30px;
    max-height:25px;
    margin-top:5%;
    background-size: contain !important;
    background-repeat: no-repeat !important;
}

.map-navigation .icon-container .profile{ 
    background:${props=>props.isDayTime?`url(${profile})`:`url(${profilenight})`} 0 0;
    background-size: cover;
    width:50px;
    height: 50px;
    scale:${props=>props.isDayTime ? "100%" : "80%" };
}
.map-navigation .icon-container .profileupdate{ 
    background:${props=>props.isDayTime?`url(${profileUpdate})`:`url(${profileUpdatenight})`} 0 0;
    background-size: cover;
    width:49px;
    height: 50px;
    scale:${props=>props.isDayTime ? "88%" : "80%" };
    @media only screen and (min-device-width: 750px) and (max-device-width: 1024px) and (orientation: portrait) 
    and (-webkit-min-device-pixel-ratio: 1) {
      width:60px;
      height:60px;
    }
}
.map-navigation .icon-container .group{ 
    background:url(${compassGroupChild}) 0 0;
    background-size: cover;
    width: 48px;
    height: 50px;
}

.map-navigation .icon-container .groupFourUnSelected{ 
    background:url(${compassGroupChildUnselected}) 0 0;
    background-size: contain;
    background-repeat: no-repeat;
    width:50px;
    height: 50px;
    bottom: 0px;
}

.map-navigation .icon-container .groupTwo{ 
    background:url(${compassGroupTwo}) 0 0;
    background-size: contain;
    background-repeat: no-repeat;
    width: 31px;
    height: 65px;
    bottom: 0px;
}

.map-navigation .icon-container .groupTwoSelected{ 
    background:url(${compassGroupTwoSelected}) 0 0;
    background-size: contain;
    background-repeat: no-repeat;
    width: 31px;
    height: 65px;
    bottom: 0px;
}

.map-navigation .icon-container .groupThree{ 
    background:url(${compassGroupThree}) 0 0;
    background-size: contain;
    background-repeat: no-repeat;
    width: 40px;
    height: 65px;
    bottom: 0px;
}

.map-navigation .icon-container .groupFour{ 
    background:url(${compassGroupChild}) 0 0;
    background-size: contain;
    background-repeat: no-repeat;
    width: 48px;
    height: 50px;
    bottom: 0px;
}

.map-navigation .icon-container .groupThreeSelected{ 
    background:url(${compassGroupThreeSelected}) 0 0;
    background-size: contain;
    background-repeat: no-repeat;
    width: 40px;
    height: 65px;
    bottom: 0px;
}

.map-navigation .icon-container .groupFive{ 
    background:url(${compassGroupFive}) 0 0;
    background-size: contain;
    background-repeat: no-repeat;
    width: 55px;
    height: 65px;
    bottom: 0px;
}

.map-navigation .icon-container .groupFiveSelected{ 
    background:url(${compassGroupFiveSelected}) 0 0;
        background-size: contain;
    background-repeat: no-repeat;
    width: 55px;
    height: 65px;
    bottom: 0px;
}

.map-navigation .icon-container .mydevelopment{ 
    background:${props=>props.isDayTime?`url(${personalDevelopment})`:`url(${personalDevelopmentnight})`} 0 0;
    background-size: cover;
    width:52px;
    height: 50px;
    top:-17%;
}
.map-navigation .icon-container .mydevelopmentSelected{ 
    background:${props=>props.isDayTime?`url(${personalDevelopmentSelected})`:`url(${personalDevelopmentSelectednight})`} 0 0;
    background-size: cover;
    width:52px;
    height: 50px;
    top:-17%;
    scale:90%;
    @media only screen and (min-device-width: 750px) and (max-device-width: 1024px) and (orientation: portrait) 
    and (-webkit-min-device-pixel-ratio: 1) {
      width:60px;
      height:60px;
    }
}
.map-navigation .icon-container .myhealth{ 
    background:${props=>props.isDayTime?`url(${health})`:`url(${healthnight})`} 0 0;
    background-size: cover;
    width:50px;
    height: 50px;
    top:-20%;
}
.map-navigation .icon-container .myhealthselected{ 
    background:${props=>props.isDayTime?`url(${healthSelected})`:`url(${healthSelectednight})`} 0 0;
    background-size: cover;
    width:50px;
    height: 50px;
    top:-20%;
    @media only screen and (min-device-width: 750px) and (max-device-width: 1024px) and (orientation: portrait) 
    and (-webkit-min-device-pixel-ratio: 1) {
      width:60px;
      height:60px;
    }
}
.map-navigation .icon-container .mywater{ 
    background:${props=>props.isDayTime?`url(${water})`:`url(${waternight})`} 0 0;
    background-size: cover;
    width:50px;
    height: 50px;
    top:-18%;
}
.map-navigation .icon-container .mywaterselected{ 
    background:${props=>props.isDayTime?`url(${waterSelected})`:`url(${waterSelectednight})`} 0 0;
    background-size: cover;
    width:50px;
    height: 50px;
    top:-18%;
    @media only screen and (min-device-width: 750px) and (max-device-width: 1024px) and (orientation: portrait) 
    and (-webkit-min-device-pixel-ratio: 1) {
      width:60px;
      height:60px;
    }
}
.map-navigation .icon-container .mycommunityselected{ 
    background:${props=>props.isDayTime?`url(${communitSelected})`:`url(${communitSelectednight})`} 0 0;
    background-size: cover;
    width:50px;
    height: 50px;
    top:-24%;
    @media only screen and (min-device-width: 750px) and (max-device-width: 1024px) and (orientation: portrait) 
    and (-webkit-min-device-pixel-ratio: 1) {
      width:60px;
      height:60px;
    }
}
.map-navigation .icon-container .mycommunity{ 
    background:${props=>props.isDayTime?`url(${community})`:`url(${communitynight})`} 0 0;
    background-size: cover;
    width:50px;
    height: 50px;
    top:-24%;
}
.map-navigation .icon-container .myeducation{ 
    background:${props=>props.isDayTime?`url(${education})`:`url(${educationnight})`} 0 0;
    background-size: cover;
    width:50px;
    height: 50px;
    top:-20%;
}
.map-navigation .icon-container .myeducationselected{ 
    background:${props=>props.isDayTime?`url(${educationSelected})`:`url(${educationSelectednight})`} 0 0;
    background-size: cover;
    width:50px;
    height: 50px;
    top:-20%;
    @media only screen and (min-device-width: 750px) and (max-device-width: 1024px) and (orientation: portrait) 
    and (-webkit-min-device-pixel-ratio: 1) {
      width:60px;
      height:60px;
    }
}
.map-navigation .icon-container .noUpdateStation{ 
    // background:url(${dot}) 0 0 no-repeat;
    width:37px;
    height: 35px;
    top:-10% !important;
    @media only screen and (min-device-width: 750px) and (max-device-width: 1024px) and (orientation: portrait) 
    and (-webkit-min-device-pixel-ratio: 1) {
      width:60px;
      height:60px;
    }
}
.map-navigation .slick-current .icon-container .circle-item:before{
    content:"";
    width:5px;
    height:5px;
    border-radius: 50%;
    position:absolute;
    top: 8px;
    right: 15%;
    background-color: #fff;
}
.map-navigation .slick-current .icon-container:after{
    content:" ";
    width:16px;
    height:16px;
    position:absolute;
    bottom:-7px;
    left:50%;
    background: url(${compassIndicator}) 0 0 no-repeat;
}
.map-navigation:before{
    content:" ";
    width:300px;
    height:16px;
    position:absolute;
    top:40px;
    left:0;
    background: url(${linecompass}) 0 0 no-repeat;
    background-size: 90%;
    @media screen and (min-width: 330px) and (max-width: 365px){
        width: 260px;
    }
    @media only screen and (min-device-width: 750px) and (max-device-width: 1199px) 
    and (orientation: portrait){ 
        top:60px;
    }
}
.community-home-nav:before{
    width:100%;
    margin-left:5%;
    @media only screen and (min-device-width: 750px) and (max-device-width: 1199px) 
    and (orientation: landscape){ 
        //margin-left: 20%;
    }
}
.map-navigation .slick-prev:before
{
    content:"\uD83E\uDC60"; 
    width:16px;
    height:16px;
    // top:5px;
    left:0;
    position:absolute;
}
.map-navigation .slick-next:before{
    content:"\uD83E\uDC62"; 
    width:16px;
    height:16px;
    // top:5px;
    right:0;
    position:absolute;
}
.slick-current{
    position:relative
}
`
export const LeftArrowGlobe = styled.img`
    position: absolute;
    width: 25px;
    height: 25px;
    top: 75px;
    left:10px;
    cursor:pointer;
    z-index:10;
    opacity: ${props=>props.enabled? "": "0.5"};
`;
export const RightArrowGlobe = styled.img`
    position: absolute;
    width: 25px;
    height: 25px;
    right:10px;
    top: 75px;
    cursor:pointer;
    z-index:10;
    opacity: ${props=>props.enabled? "": "0.5"};
`;

export const WorldDataHome = styled.div `
@media only screen and (min-device-width: 750px) and (max-device-width: 1199px) and (orientation: landscape) 
    {
        display:none;
    }
`
export const CountryCompImg = styled.div`
    min-width: 50px;
    max-width: 50px;
    margin: 0.5em;
    height: 50px;
    @media only screen and (max-width: 750px){
        min-width: 40px;
        max-width: 40px;
        margin-right:2px;
    }
    & img {
        width: 100%;
        height: 100%;
        padding-right: 10px;
        margin: 0 auto;
    }
`

export const CommunityHomeViewArrows = styled.div `
    position:relative;
    top:4vh;
    @media only screen and (min-device-width: 750px) and (max-device-width: 1199px) and (orientation: landscape) 
   {
        & {
            top:-4vh;
        }
    }  

`
export const CommunityHomeViewLeftArrow = styled.img`
    position: absolute;
    width: 25px;
    height: 25px;
    top: 0px;
    left:10px;
    cursor:pointer;
    z-index:10;
    opacity: ${props=>props.enabled? "": "0.5"};
    @media only screen and (min-device-width: 750px) and (max-device-width: 1199px) and (orientation: landscape) 
    {
        & {
            left: 26%;
        }
    } 
    @media only screen and (min-device-width: 750px) and (max-device-width: 1199px) and (orientation: portrait) 
    {
        & {
            top: 20px;
            left: 8%;
            width: 35px;
            height: 35px;
        }
    }  
`;
export const CommunityHomeViewRightArrow = styled.img`
    position: absolute;
    width: 25px;
    height: 25px;
    right:5px;
    top: 0px;
    cursor:pointer;
    z-index:10;
    opacity: ${props=>props.enabled? "": "0.5"};
    @media only screen and (min-device-width: 750px) and (max-device-width: 1199px) and (orientation: portrait) 
    {
        & {
            top: 18px;
            right: 9%;
            width: 35px;
            height: 35px;
        }
    } 
    @media only screen and (min-device-width: 750px) and (max-device-width: 1199px) and (orientation: landscape) 
    {
        & {
            right: 26%;
        }
    } 
`;
